// extracted by mini-css-extract-plugin
export default {"details":"AdminCompany_details__k+XVa","filtersModalForm":"AdminCompany_filtersModalForm__JOGK7"};